import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AuthApiService } from '@auth/services/auth-api.service';
import { AuthCheckService } from '@auth/services/auth-check.service';
import { PortalService } from '@auth/services/portal.service';
import { DarkThemeService } from '@core/theme/dark-theme.service';
import { AsideService } from '@services/aside.service';
import { HomeSidebarService } from '@services/home-sidebar.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sume-home-header',
    templateUrl: './home-header.component.html',
    styleUrls: ['./home-header.component.scss'],
})
export class HomeHeaderComponent implements OnInit, OnDestroy {
    is_public: boolean = true;
    is_dev = !environment.production;

    sidebar_active = false;
    isLoadingResults = true;
    enablePortais = false;

    subscriptions: Subscription[] = [];

    constructor(
        private apiSidebar: HomeSidebarService,
        private asideService: AsideService,
        private authApiService: AuthApiService,
        private router: Router,
        private spinner: NgxSpinnerService,
        public authCheckService: AuthCheckService,
        public darkThemeService: DarkThemeService,
        public portalService: PortalService
    ) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.apiSidebar
                .getStatus()
                .subscribe(status => (this.sidebar_active = status))
        );
        this.subscriptions.push(
            this.portalService.loading$
                .pipe(filter(() => this.authCheckService.isLogged))
                .subscribe(l => {
                    if (l) this.spinner.show('seletor-portais');
                    else this.spinner.hide('seletor-portais');
                })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    logoutUser() {
        this.authApiService.logout();
    }

    toggleSidebar() {
        this.apiSidebar.updateStatus(!this.sidebar_active);
    }
    toggleAside() {
        this.asideService.toggle();
    }

    gotoHome() {
        const link_home = `/${this.portalService.portal}`;
        this.router.navigateByUrl(link_home || '/');
    }
}
